import { error } from 'app/infrastructure/log';

type TemplateElement = string | TooltipSectionElement;

export class TooltipSectionElement {
  constructor(public section: string, public fields: TemplateElement[]) {
  }
}

export class TooltipParser {

  private static fieldPattern: RegExp = /^\s*([^\s,:\[\]]+)\s*(?:,|$)/;
  private static sectionPattern: RegExp = /^\s*([^\s,:\[\]]+)\s*:\s*\[([^\]]*)\]\s*(?:,|$)/;

  public parse(template: string): TemplateElement[] {

    if (!template || template.length === 0) {
      return null;
    }

    const ret: TemplateElement[] = [];

    while (template.length > 0) {

      const fieldResult = TooltipParser.fieldPattern.exec(template);
      if (fieldResult && fieldResult.length === 2 && fieldResult[0].length > 0) {
        ret.push(fieldResult[1]);
        template = template.slice(fieldResult[0].length);
        continue;
      }

      const sectionResult = TooltipParser.sectionPattern.exec(template);
      if (sectionResult && sectionResult.length === 3 && sectionResult[0].length > 0) {
        ret.push(new TooltipSectionElement(sectionResult[1], this.parse(sectionResult[2])));
        template = template.slice(sectionResult[0].length);
        continue;
      }

      error('Unable to parse tooltip: ' + template);
      return null;
    }

    return ret;
  }
}
